<template>
  <H5 :backPrev="backPrev" :showBackTip="showBackTip" v-if="isMobilePage" @exam-title-change="setExamTitle" />
  <PC :backPrev="backPrev" :showBackTip="showBackTip" v-else />
</template>
<script>
import PC from './pc'
import H5 from './h5'

export default {
  components: {
    PC,
    H5
  },
  data() {
    return {
      showBackTip: false, // 展示后退警告
      currentNext: null, // 当前后退的next函数
      previousDocumentTitle: ''
    }
  },
  computed: {
    isMobilePage() {
      return this.$route.meta.platform === 'mobile' || this.isMobileDevice
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.params.noBackTip) {
      next()
    } else {
      this.showBackTip = true
      this.currentNext = next
    }
  },
  created() {
    if (this.isMobilePage) {
      this.previousDocumentTitle = document.title
    }
  },
  destroyed() {
    if (this.isMobilePage) {
      document.title = this.$store.state.theme.title || this.previousDocumentTitle
    }
  },
  methods: {
    setExamTitle(examName) {
      if (examName) {
        document.title = examName
      }
    },
    backPrev (isBack) {
      this.showBackTip = false
      isBack ? this.currentNext() : this.currentNext(false)
      this.currentNext = null
    }
  }
}
</script>
